<template>
<div class="chapter">
<div class="inner_page">
<div class="fs" id="page011">
<div class="jstfy" id="page011_1">RECIPES</div>
<div class="jstfy" id="page011_2">All recipes serve four people.</div>
<div class="jstfy" id="page011_3">The appropriate information is given where there are any exceptions.</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// page_011.vue?4cdc2772